module.exports = __webpack_public_path__ + "static/media/visa.2b12c62a.svg";